// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".step-info[data-v-720e17f8]{max-width:272px}.rewards-prompt-container p[data-v-720e17f8]{max-width:var(--content-max-width)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
